// extracted by mini-css-extract-plugin
export default {"del":"VariantDel_del__ddelG"};